const ja = {
  transactionDate: "取引日",
  totalTXNs: "合計トランザクション数",
  successTXNs: "成功件数",
  riskDeclinedTXNs: "リスク管理拒否の数",
  bankDeclinedTXNs: "銀行拒否件数",
  otherDeclinedTXNs: "その他の失敗したトランザクションの数",
  txnSuccessRate: "取引成功率",
  bankDeclinedTXNsExcluded: "取引成功率（カード所有者の理由を除く）",
  group: "グループ",
  store: "Webサイト",
  omniStore: "ウェブサイト・店舗",
  currency: "取引通貨",
  tradeAnalysis: "取引分析",
  saleData: "販売データ",
  export: "エクスポート",
  succAmount: "成功額",
  succAmountDesc: "金額はあくまで参考値です。通貨別に表示したい場合は「取引通貨」を指定してください",
  refundAnalysis: "返金分析",
  refundRate: "返金率",
  refundAmount: "返金額",
  numberRefund: "返金件数",
  refundAmtRatio: "払戻金額比率",
  refundRateTip: "返金率 = 返金数 (重複の削除) / 成功した取引の数。払戻金額比率＝払戻金額／成功金額",
  succRate: '成功率',
  succRateAnalysis: '成功率分析',
  succRateTip: "成功率 = 成功したトランザクションの数 / PingPongPay によって受け入れられたトランザクションの総数",
  TXN: "注: TXN はトランザクションを指します",
  regionDistri: "国/地域の分布 (成功したトランザクションの数)",
  cbIn6: "過去 6 か月間のチャージバック データ",
  cbRate: "チャージバック率",
  total: "合計",
  cbNumber: "チャージバック件数",
  cbReason: "チャージバックの理由",
  fraud: "不正利用",
  notAsDescribed: "商品相違",
  notReceived: "商品未着",
  other: "その他",
  chargebackAnalysis: "チャージバック分析",
  cbWarning: "チャージバックアラート",
  cbWarningAmount: "警告量",
  cbWarningCnt: "早期警告の数",
  covertedUSD: "※通貨が異なるため、アラート金額はUSD換算で計算されます（参考値）。",
  month: "月",
  amount: "金額",
  number: "成功件数",
  count: "件数",
  day7: "過去7日間",
  day30: "ほぼ一ヶ月",
  day90: "過去3ヶ月",
  day180: "過去6ヶ月",
  currentMonth: "今月",
  current: "今期",
  compare: "同時期",
  compareText: "比較",
  lastPeriod: "前号",
  lastMonth: "先月",
  lastQuarter: "最後の四半期",
  lastYear: '去年',
  noCompare: "コントラストなし",
  custom: "カスタマイズ",
  quantities: "量",
  tipText: "ヒント: 統計時間は UTC +0 に基づいています。",
  refundTipText: "金額はあくまで参考値です。通貨別に表示する必要がある場合は、通貨を指定してください。",
  cbRateTipText: "拒否率 = 拒否数/取引成功数",
  queryType: "検索",
  paymentMethod: "支払方法",
  country: "国と地域",
  failAnalysis: "失敗理由の分析",
  failReasonRatio: "失敗理由の割合",
  failureTip: "失敗の理由は、注文ディメンションではなくリクエスト ディメンションのデータを分析することです。",
  type: "タイプ",
  comparisonTable: "失敗タイプとPPステータスコードの対照表",
  klarnaAnalysis: "Klarna異議申立分析",
  disputeRate: "異議申立率",
  disputeRateTips: "紛争率 = 月内の Klarna 紛争の数 / 月内の成功したトランザクションの数",
  disputeEscalationRate: "異議申立エスカレーション率",
  disputeEscalationRateTips: "紛争エスカレーション率 = その月の Klarna 調整数 (エスカレートされた紛争) / その月に完了したトランザクションの数",
  disputeReason: "異議申立理由",
  retrievalReason: "取引照会理由",
  returns: "商品を返品する",
  goodsNotReceived: "商品未着",
  incorrectInvoice: "請求エラー",
  faultyGoods: "不良品",
  alreadyPaid: "繰り返しの支払い",
  unauthorizedPurchases: "無許可",
  successfulTransactions: "成功件数",
  time: "期間",
  dispute: "異議申立件数",
  retrieval: "異議申立エスカレーション件数（照会）",
  chargeback: "チャージバック件数（敗訴）",
  disputeListTitle: "過去 3 暦月の紛争データの概要",
  disputeListWarn: "あなたの会社の紛争エスカレーション率は 2 か月連続で基準 (≧1.5%) を超えています。紛争のエスカレーション率を減らすためにタイムリーな措置を講じてください。"
};
export default ja;